// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { startOfISOWeek as fn } from "../startOfISOWeek.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const startOfISOWeekWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default startOfISOWeekWithOptions;
